
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { TimeFrameItemProps } from ".";
import { loading, find } from "store/time-frame";

interface ApiTimeFrameFindByIdInputProps {
    id: number;
}

type ApiTimeFrameFindOutputProps = OutputBaseProps<{ item: TimeFrameItemProps; }, ApiTimeFrameFindByIdInputProps>;

export const apiTimeFrameFindById = async (data: ApiTimeFrameFindByIdInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiTimeFrameFindOutputProps>(`/api/time-frame/${data.id}`))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(find({ data: res.data.item }));
    }
    return res;
};